import * as Colors from 'ui-library/Colors';

export const PART_ANNOTATION_COLOR = '#0B818E';
export const PART_ANNOTATION_ARCHIVED_COLOR = Colors.GRAY;
export const PART_NAME_FONT_SIZE = 13;
export const PART_ANNOTATION_OUT_OF_SYNC_COLOR = Colors.RED_DARK;
export const PART_STROKE_COLOR = Colors.GRAY;
export const PART_ANNOTATION_ARCHIVED_OPACITY = 0.5;
export const SINGLE_ANNOTATION_BORDER = 1;
export const SINGLE_ANNOTATION_HEIGHT = 12;

export function getColor(outOfSync: boolean, isArchived: boolean): string {
  if (outOfSync) {
    return PART_ANNOTATION_OUT_OF_SYNC_COLOR;
  } else if (isArchived) {
    return PART_ANNOTATION_ARCHIVED_COLOR;
  } else {
    return PART_ANNOTATION_COLOR;
  }
}
